import React, { useEffect, useState } from "react";

import styles from "./CommunityHub.module.scss";
import Button from "components/Button";
import images from "assets/images";
import Marquee from "react-fast-marquee";
import useResizeWidth from "controller/useResizeWidth";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import EffectMaterial from "../../library/dist/effect-material.esm.js";
import ReactTextTransition, { presets } from "react-text-transition";

import "../../library/dist/effect-material.scss";
import GhostContentAPI from "@tryghost/content-api";

const arrSlides = [
  images.communityBanner1,
  images.communityBanner2,
  images.communityBanner3,
  images.communityBanner4,
  images.communityBanner5,
  images.communityBanner6,
  images.communityBanner7,
  images.communityBanner8,
  images.communityBanner9,
  images.communityBanner10,
  images.communityBanner1,
  images.communityBanner2,
  images.communityBanner3,
  images.communityBanner4,
  images.communityBanner5,
  images.communityBanner6,
  images.communityBanner7,
  images.communityBanner8,
  images.communityBanner9,
  images.communityBanner10,
];

const arrSocials = [
  {
    name: "Telegram",
    subName: "Viction Announcement",
    description: "Find all announcements in the official Telegram channel.",
    icon: images.telegramIcon,
    link: "http://t.me/buildonviction",
  },
  {
    name: "Discord",
    subName: "Viction",
    description:
      "Join Viction’s vibrant community on Discord to collaborate, share ideas, and get support.",
    icon: images.discordIcon,
    link: "https://discord.gg/gDffVfqGtX",
  },
  {
    name: "YOUTUBE",
    subName: "Viction",
    description:
      "Watch tutorials, events, and updates on Viction’s official YouTube channel.",
    icon: images.youtubeIcon,
    link: "http://www.youtube.com/@buildonviction",
  },
  {
    name: "GITHUB",
    subName: "Viction",
    description:
      "Explore cutting-edge projects, contribute to code, and be part of the innovation shaping the ecosystem.",
    icon: images.githubIcon,
    link: "https://github.com/buildonviction",
  },
  {
    name: "X",
    subName: "Viction",
    description:
      "Explore cutting-edge projects, contribute to code, and be part of the innovation shaping the ecosystem.",
    icon: images.xIcon,
    link: "https://x.com/BuildOnViction",
  },
  {
    name: "X",
    subName: "Viction Ecosystem",
    description:
      "Explore cutting-edge projects, contribute to code, and be part of the innovation shaping the ecosystem.",
    icon: images.xIcon,
    link: "https://x.com/VictionEco",
  },
  {
    name: "X",
    subName: "Viction Foundation",
    description:
      "Explore cutting-edge projects, contribute to code, and be part of the innovation shaping the ecosystem.",
    icon: images.xIcon,
    link: "https://x.com/VictionFND",
  },
];

const arrGovernance = [
  {
    title: "Viction Governance",
    description: "Learn about the framework, how to become a voter",
    image: images.communityGovernance1,
    buttonText: "Explore Proposals",
    link: "https://gov.viction.xyz/",
  },
  {
    title: "Viction Forum",
    description:
      "Where you can propose new ideas, discuss protocols, and contribute to ongoing projects",
    image: images.communityGovernance2,
    buttonText: "Join Now",
    link: "https://forum.viction.xyz/",
  },
];

const arrBlogNew = [
  {
    title: "Trust The Progress - 10,000$ in VIC Up for Grabs!",
    description:
      "April was a defining month for the Viction ecosystem as we moved boldly into a new chapter of growth. With major integrations, token launches, governance upgrades, and vibrant community action, the momentum only intensified.",
    image: images.blogNew1,
    link: "/",
  },
  {
    title: "Viction Game Awards - Spring Edition: Blaze Your Inner Flame",
    description:
      "January was a remarkable month for Viction, filled with new integrations, exciting milestones, community-driven initiatives, and rewarding campaigns.",
    image: images.blogNew2,
    link: "/",
  },
  {
    title: "Viction DA Mainnet is LIVE",
    description: "Find all announcements in the official Telegram channel.",
    image: images.blogNew3,
    link: "/",
  },
];

const arrProgramEvent = [
  {
    image: images.programEventExample,
    title: "Viction Game Awards",
    description:
      "Since the rebranding in November 2023, the Viction ecosystem has kept expanding and now includes hundreds of live projects.",
    status: "Past",
    time: "7/12/2024-20/1/2025",
    location: "HCMC & Online",
  },
  // {
  //   image: images.programEvent,
  //   title: "731 VMs Party: Vietnam 🇻🇳",
  //   description:
  //     "Tháng 11 này, chúng ta không chỉ kết nối trên chain mà còn sẽ gặp mặt IRL (In Real Life) để cùng nhau làm một việc cực kỳ quan trọng: MỪNG SINH NHẬT VICTION TRÒN 2 TUỔI! 🥳",
  //   status: "On Going",
  //   time: "15/11/2025",
  //   location: "HCMC & Online",
  // },
  // {
  //   image: images.programEvent2,
  //   title: "731 VMs Party: Thailand 🇹🇭",
  //   description:
  //     "Viction 2nd Birthday Party Celebrating 731 days of Viction. From the blockchain world to heartwarming real-life moments. 💛",
  //   status: "On Going",
  //   time: "15/11/2025",
  //   location: "HCMC & Online",
  // },
  // {
  //   image: images.programEvent3,
  //   title: "731 VMs Party: Philippines 🇵🇭",
  //   description:
  //     "731 days of Viction — and we’re still vibin’, buildin’, and makin’ moves together.",
  //   status: "On Going",
  //   time: "16/11/2025",
  //   location: "HCMC & Online",
  // },
  // {
  //   image: images.programEvent,
  //   title: "731 VMs Party: Vietnam 🇻🇳",
  //   description:
  //     "Tháng 11 này, chúng ta không chỉ kết nối trên chain mà còn sẽ gặp mặt IRL (In Real Life) để cùng nhau làm một việc cực kỳ quan trọng: MỪNG SINH NHẬT VICTION TRÒN 2 TUỔI! 🥳",
  //   status: "On Going",
  //   time: "15/11/2025",
  //   location: "HCMC & Online",
  // },
  // {
  //   image: images.programEvent2,
  //   title: "731 VMs Party: Thailand 🇹🇭",
  //   description:
  //     "Viction 2nd Birthday Party Celebrating 731 days of Viction. From the blockchain world to heartwarming real-life moments. 💛",
  //   status: "On Going",
  //   time: "15/11/2025",
  //   location: "HCMC & Online",
  // },
  // {
  //   image: images.programEvent3,
  //   title: "731 VMs Party: Philippines 🇵🇭",
  //   description:
  //     "731 days of Viction — and we’re still vibin’, buildin’, and makin’ moves together.",
  //   status: "On Going",
  //   time: "16/11/2025",
  //   location: "HCMC & Online",
  // },
];

function CommunityHub() {
  const { isMobile } = useResizeWidth();
  const [swiperInstance, setSwiperInstance] = useState(0);
  const [programEventContent, setProgramEventContent] = useState(
    arrProgramEvent[0],
  );
  const [isChangeProgramEvent, setIsChangeProgramEvent] = useState(false);
  const [postBlog, setPostBlog] = useState([]);

  const api = new GhostContentAPI({
    url: "https://tomochain.ghost.io", // e.g., 'https://demo.ghost.io'
    key: "0a14e2572b7246083c136637aa", // e.g., '22444f78447824223cefc48062'
    version: "v6.0", // Use the version relevant to your Ghost install
  });

  const fetchPosts = async () => {
    try {
      const posts = await api.posts.browse({ limit: 3 });
      setPostBlog(posts);
      console.log("Fetched posts:", posts);
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  const handleSwiper = (swiper) => {
    setProgramEventContent(arrProgramEvent[swiper.realIndex]);
    setIsChangeProgramEvent(true);

    setTimeout(() => {
      setIsChangeProgramEvent(false);
    }, 1000);
  };

  useEffect(() => {
    // Fetch all posts
    fetchPosts();
  }, []);

  return (
    <div className={styles.communityHub}>
      <div className="community-hub">
        <div className="community-hub-banner">
          <div className="community-hub-banner-container">
            <div className="hub-banner-title">Viction Community</div>

            <div className="hub-banner-description">
              From one community to the next billion
            </div>

            <div className="hub-banner-action">
              <a
                href="https://x.com/BuildOnViction"
                target="_blank"
                rel="noreferrer"
              >
                <Button>
                  Jump in{" "}
                  <span className="icon-web_arrow_up_right icon-arrow"></span>
                </Button>
              </a>
            </div>
          </div>

          <div className="community-hub-banner-slide">
            <img
              src={images.curveWhite}
              alt=""
              className="img-curve img-curve--down"
            />
            <img
              src={images.curveWhite}
              alt=""
              className="img-curve img-curve--up"
            />

            <Marquee>
              {arrSlides.map((item, index) => {
                return (
                  <div className="banner-img" key={index}>
                    <img src={item} className="item-banner" alt="" />
                  </div>
                );
              })}
            </Marquee>
          </div>
        </div>

        <div className="community-start">
          <div className="community-start-container">
            <div className="community-start-title">
              <div className="start-title">
                Start Your Viction Community Journey
              </div>

              <div className="start-description">
                Connect. Innovate. Evolve.
              </div>
            </div>

            <div className="community-start-social">
              {arrSocials.map((item, index) => {
                return (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                    key={index}
                  >
                    <div className="social-item">
                      <img src={item.icon} alt="" className="icon-social" />

                      <div className="social-content">
                        <div className="social-name">
                          <div className="text-name">
                            {item.name} <div className="dot"></div>
                          </div>
                          <div>{item.subName}</div>
                        </div>

                        <div className="social-description">
                          {item.description}
                        </div>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="program-and-event">
          <div className="program-and-event-container">
            <div className="program-and-event-title">
              <div className="title-head">
                <div className="text-title">Explore Our Programs & Events</div>

                <div className="text-description">Learn. Build. Drive.</div>
              </div>

              <div className="title-action">
                <a
                  href="https://viction.xyz/event"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button>
                    All events <span className="icon-web_arrow_up_right"></span>
                  </Button>
                </a>
              </div>
            </div>
          </div>

          <div className="program-and-event-content">
            <Swiper
              // spaceBetween={2}
              // breakpoints={{
              //   1024: {
              //     slidesPerView: 1,
              //   },
              //   1280: {
              //     slidesPerView: 2,
              //   },
              // }}
              // pagination={{
              //   clickable: true,
              //   dynamicBullets: true,
              // }}
              // navigation={{
              //   prevEl: ".icon-web_arrow_left",
              //   nextEl: ".icon-web_arrow_right",
              // }}
              materialEffect={{
                slideSplitRatio: 1.6,
              }}
              loop={true}
              effect="material"
              // onSlideChange={handleSwiper}
              modules={[Pagination, EffectMaterial, Navigation]}
              className="program-event-slide"
            >
              {arrProgramEvent.map((item, index) => {
                return (
                  <SwiperSlide key={index} className="item-program-wrapper">
                    <div className="swiper-material-wrapper">
                      <div className="item-program">
                        <img src={item.image} alt="" className="img-program" />
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>

            <div className="content-detail">
              <div className="item-program-content">
                <div className="content-head">
                  <div
                    className={`item-program-info ${
                      isChangeProgramEvent && "item-program-info--change"
                    }`}
                  >
                    <div className="item-program-info--status">
                      {programEventContent.status}
                    </div>
                    {!isMobile && <div className="dot"></div>}

                    <div className="text-info-wrapper">
                      <div className="item-program-info--time">
                        {programEventContent.time}
                      </div>
                      <div className="dot"></div>
                      <div className="item-program-info--local">
                        {programEventContent.location}
                      </div>
                    </div>
                  </div>

                  <div className="item-program-name">
                    <div className={`name-text`}>
                      <ReactTextTransition
                        springConfig={presets.gentle}
                        className="big"
                        delay={300}
                        inline
                      >
                        {programEventContent.title}
                      </ReactTextTransition>
                    </div>
                  </div>
                </div>

                <div className="content-action">
                  <div
                    className={`content-action-description ${
                      isChangeProgramEvent &&
                      "content-action-description--change"
                    }`}
                  >
                    {programEventContent.description}
                  </div>

                  <div className="content-action-button">
                    <div className="action-left">
                      <a
                        href="https://calendar.google.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Button>
                          <span className="icon-ic-wallet"></span>
                          Add to calendar
                        </Button>
                      </a>

                      <div className="more-action">
                        <a
                          href="https://gameawards.viction.xyz/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="text-more text-hover-underline-white">
                            More details
                          </div>
                        </a>
                      </div>
                    </div>
                    {/* 
                    <div className="action-right">
                      <span className="icon-web_arrow_left icon-arrow"></span>
                      <span className="icon-web_arrow_right icon-arrow"></span>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="community-frontier">
          <div className="img-frontier img-frontier--img-1">
            <img src={images.communityFrontier1} alt="" />
          </div>

          <div className="img-frontier img-frontier--img-2">
            <img src={images.communityFrontier2} alt="" />
          </div>

          <div className="img-frontier img-frontier--img-3">
            <img src={images.communityFrontier3} alt="" />
          </div>

          <div className="community-frontier-container">
            <div className="community-frontier-text">
              <div className="frontier-title">
                Elevate Your Impact With FrontierDAO
              </div>

              <div className="frontier-description">Own It Together</div>
              <div className="frontier-action">
                <a
                  href="https://x.com/Frontier_DAO"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button>
                    Lead The Way{" "}
                    <span className="icon-web_arrow_up_right icon-arrow"></span>
                  </Button>
                </a>
              </div>
            </div>
          </div>

          <div className="img-frontier img-frontier--img-4">
            <img src={images.communityFrontier4} alt="" />
          </div>

          <div className="img-frontier img-frontier--img-5">
            <img src={images.communityFrontier5} alt="" />
          </div>

          <div className="img-frontier img-frontier--img-6">
            <img src={images.communityFrontier6} alt="" />
          </div>

          <div className="img-frontier img-frontier--img-7">
            <img src={images.communityFrontier7} alt="" />
          </div>

          <div className="img-frontier img-frontier--img-8">
            <img src={images.communityFrontier8} alt="" />
          </div>

          <img src={images.curveBlack2} alt="" className="img-curve-black" />
        </div>

        <div className="community-governance">
          <div className="community-governance-container">
            <div className="governance-title">Governance</div>

            <div className="governance-content">
              {arrGovernance.map((item, index) => {
                return (
                  <div className="governance-item" key={index}>
                    <div className="governance-item--thumbnail">
                      <img src={item.image} alt="" className="img-thumbnail" />
                    </div>

                    <div className="governance-item--info">
                      <div className="info-title">{item.title}</div>
                      <div className="info-description">{item.description}</div>

                      <div className="info-action">
                        <a href={item.link} target="_blank" rel="noreferrer">
                          <Button variant="secondary">
                            {item.buttonText}{" "}
                            <span className="icon-web_arrow_up_right icon-arrow"></span>
                          </Button>
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="community-blog-new">
          <div className="community-blog-new-container">
            <div className="community-blog-new-title">
              <div className="blog-new-title">Blogs & News</div>

              <div className="blog-new-more">
                <a
                  href="https://blog.viction.xyz/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="text-more text-hover-underline">
                    Read More
                  </div>
                </a>
              </div>
            </div>

            <div className="community-blog-new-content">
              {postBlog.map((item, index) => {
                return (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                    key={index}
                  >
                    <div className="blog-new-item">
                      <div className="blog-new-thumbnail">
                        <img
                          src={item.feature_image}
                          alt=""
                          className="img-thumbnail"
                        />
                      </div>

                      <div className="blog-new-content">
                        <div className="info-title">{item.title}</div>
                        <div className="info-description">{item.excerpt}</div>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommunityHub;
